import { useMemo, useState } from 'react';
import { articles, categories } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';
import SectionHeading from '@/components/base/SectionHeading';

const tabs = [{ slug: 'all', name: '全部' }, ...categories.map((c) => ({ slug: c.slug, name: c.name }))];

export default function LatestFeed() {
  const [active, setActive] = useState('all');
  const [keyword, setKeyword] = useState('');

  const list = useMemo(() => {
    const byCategory =
      active === 'all' ? articles : articles.filter((a) => a.category === active);
    const kw = keyword.trim().toLowerCase();
    if (!kw) return byCategory;
    return byCategory.filter(
      (a) =>
        a.title.toLowerCase().includes(kw) ||
        a.summary.toLowerCase().includes(kw) ||
        a.tags.some((t) => t.toLowerCase().includes(kw)),
    );
  }, [active, keyword]);

  return (
    <section aria-label="最新爆料" className="mx-auto mt-16 w-full max-w-[1280px] px-4 md:mt-20 md:px-6">
      <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
        <SectionHeading
          eyebrow="最新爆料"
          title="每日更新的第一手消息"
          desc="按分类浏览，或直接搜索你关心的话题关键词。"
        />
        <div className="relative w-full lg:w-72">
          <i
            className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-base text-foreground-400"
            aria-hidden="true"
          ></i>
          <input
            type="search"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜索标题、标签…"
            aria-label="搜索内容"
            className="w-full rounded-md border border-background-300 bg-background-50 py-2.5 pl-10 pr-3 text-sm text-foreground-950 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
          />
        </div>
      </div>

      <div className="mt-6 flex flex-wrap gap-2">
        {tabs.map((tab) => (
          <button
            key={tab.slug}
            type="button"
            onClick={() => setActive(tab.slug)}
            className={`rounded-full px-4 py-2 text-sm whitespace-nowrap transition-colors ${
              active === tab.slug
                ? 'bg-primary-500 text-background-50 dark:text-foreground-950 font-medium'
                : 'border border-background-300 bg-background-50 text-foreground-700 hover:bg-background-100'
            }`}
          >
            {tab.name}
          </button>
        ))}
      </div>

      {list.length > 0 ? (
        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((a) => (
            <ArticleCard key={a.id} article={a} />
          ))}
        </div>
      ) : (
        <div className="mt-10 flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 py-16 text-center">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-background-200 text-foreground-500">
            <i className="ri-file-search-line text-2xl" aria-hidden="true"></i>
          </span>
          <p className="mt-4 text-sm text-foreground-600">没有找到匹配的内容，换个关键词试试。</p>
        </div>
      )}
    </section>
  );
}